import { MenuItem } from '@v2/shared/lib/types';
import { MenuPanel } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import useToggle from '@v2/shared/lib/useToggle';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';

import SpecialDealItem from './SpecialDealItem';
import SpecialDealsDialog from './SpecialDealsDialog';

type Props = {
  specialDealLinks: MenuItem[];
  closeMainMenu: () => void;
};

export default function SpecialDealsPanel({ specialDealLinks, closeMainMenu }: Props) {
  const { isOpen: showSpecialDealsMenu, toggle: toggleSpecialDeals, close: closeSpecialDeals } = useToggle();

  return (
    <>
      <MenuPanel>
        <MenuPanel.Title
          title="Special deals"
          onClick={toggleSpecialDeals}
          showButton
          button={{ text: 'View all', icon: faLongArrowRight }}
        />
        <div className="flex overflow-hidden overflow-x-auto mb-2" style={{ maxWidth: '100vw' }}>
          {specialDealLinks.map((specialDeal) => (
            <SpecialDealItem key={specialDeal.title} {...specialDeal} />
          ))}
        </div>
      </MenuPanel>

      <SpecialDealsDialog
        isOpen={showSpecialDealsMenu}
        toggle={toggleSpecialDeals}
        close={closeSpecialDeals}
        specialDealLinks={specialDealLinks}
        closeMainMenu={closeMainMenu}
      />
    </>
  );
}
